export const congregationKeys = {
  root: ['congregation'] as const,
  me: () => [...congregationKeys.root, 'me'] as const,
  masters: () => [...congregationKeys.root, 'masters'] as const,
  admin: 'admin' as const,
  devotees: 'devotees' as const,
  profile: (memberId?: number) =>
    [...congregationKeys.root, 'profile', typeof memberId === 'number' ? memberId : 'self'] as const,
  contacts: () => [...congregationKeys.root, 'contacts'] as const,
  addresses: () => [...congregationKeys.root, 'addresses'] as const,
  family: () => [...congregationKeys.root, 'family'] as const,
  manualRelatives: () => [...congregationKeys.root, 'manual-relatives'] as const,
  chanting: () => [...congregationKeys.root, 'chanting'] as const,
  books: () => [...congregationKeys.root, 'books'] as const,
  courses: () => [...congregationKeys.root, 'courses'] as const,
  milestones: () => [...congregationKeys.root, 'milestones'] as const,
  documents: () => [...congregationKeys.root, 'documents'] as const,
  photos: () => [...congregationKeys.root, 'photos'] as const,
  households: (params?: { memberId?: number | null }) =>
    [
      ...congregationKeys.root,
      'households',
      typeof params?.memberId === 'number' ? params.memberId : 'self',
    ] as const,
  householdDetail: (householdId: number) =>
    [...congregationKeys.root, 'households', householdId] as const,
  applications: () => [...congregationKeys.root, 'applications'] as const,
  applicationDetail: (applicationId: number) =>
    [...congregationKeys.root, 'applications', applicationId] as const,
  mentorApplications: (params?: { statuses?: string[]; search?: string }) =>
    [
      ...congregationKeys.root,
      'mentor-applications',
      params?.search?.trim().toLowerCase() || 'all',
      params?.statuses?.join('|') ?? 'all',
    ] as const,
  birthdays: (params?: { windowDays?: number; limit?: number; centerId?: number }) =>
    [
      ...congregationKeys.root,
      'birthdays',
      params?.windowDays ?? 'default',
      params?.limit ?? 'default',
      params?.centerId ?? 'all',
    ] as const,
  anniversaries: (params?: { windowDays?: number; limit?: number; centerId?: number }) =>
    [
      ...congregationKeys.root,
      'anniversaries',
      params?.windowDays ?? 'default',
      params?.limit ?? 'default',
      params?.centerId ?? 'all',
    ] as const,
  mentorNotifications: () => [...congregationKeys.root, 'mentor-notifications'] as const,
  mentorAuditEvents: () => [...congregationKeys.root, 'mentor-audit-events'] as const,
  mentorSadhanaTemplates: (params?: { includeItems?: boolean }) =>
    [
      ...congregationKeys.root,
      'mentor-sadhana',
      'templates',
      params?.includeItems ? 'with-items' : 'summary',
    ] as const,
  mentorSadhanaTemplateAssignment: (memberId?: number | 'self') =>
    [...congregationKeys.root, 'mentor-sadhana', 'template-assignment', memberId ?? 'self'] as const,
  mentorSadhanaTemplateAssignments: (memberId?: number | 'self') =>
    [...congregationKeys.root, 'mentor-sadhana', 'template-assignments', memberId ?? 'self'] as const,
  mentorSadhanaWeeks: (params?: { memberId?: number | null; limit?: number; before?: string | null }) =>
    [
      ...congregationKeys.root,
      'mentor-sadhana',
      'weeks',
      params?.memberId ?? 'self',
      params?.limit ?? 'default',
      params?.before ?? 'latest',
    ] as const,
  mentorSadhanaWeekDetail: (weekId: number, memberId?: number | 'self') =>
    [...congregationKeys.root, 'mentor-sadhana', 'week', weekId, memberId ?? 'self'] as const,
  mentorSadhanaPrescriptions: (memberId?: number | 'self') =>
    [...congregationKeys.root, 'mentor-sadhana', 'prescriptions', memberId ?? 'self'] as const,
  mentorSadhanaAnalytics: (params?: {
    weeks?: number | null;
    since?: string | null;
    until?: string | null;
    devoteeMemberId?: number | null;
  }) =>
    [
      ...congregationKeys.root,
      'mentor-sadhana',
      'analytics',
      params?.weeks ?? 'default',
      params?.since ?? 'auto',
      params?.until ?? 'auto',
      params?.devoteeMemberId ?? 'all',
    ] as const,
  devoteeSadhanaWeeks: (params?: { limit?: number | null; before?: string | null }) =>
    [
      ...congregationKeys.root,
      'devotee-sadhana',
      'weeks',
      params?.limit ?? 'default',
      params?.before ?? 'latest',
    ] as const,
  devoteeSadhanaWeek: (weekId?: number | 'current', date?: string | 'auto') =>
    [...congregationKeys.root, 'devotee-sadhana', 'week', weekId ?? 'current', date ?? 'auto'] as const,
  mentorDevoteeSadhanaWeek: (devoteeMemberId: number, date?: string | 'auto') =>
    [...congregationKeys.root, 'mentor', 'devotee-sadhana', 'week', devoteeMemberId, date ?? 'auto'] as const,
  devoteeSadhanaDailyEntry: (
    weekId: number | 'current',
    itemId: number,
    entryDate: string,
  ) => [...congregationKeys.root, 'devotee-sadhana', 'entry', weekId, itemId, entryDate] as const,
  devoteeSadhanaMentorFeedback: (weekId?: number | 'current') =>
    [...congregationKeys.root, 'devotee-sadhana', 'mentor-feedback', weekId ?? 'current'] as const,
  devoteeSadhanaPrescriptions: () =>
    [...congregationKeys.root, 'devotee-sadhana', 'prescriptions', 'self'] as const,
  mentorDevotees: () =>
    [...congregationKeys.root, 'mentor', 'sadhana', 'devotees'] as const,
};
